





















































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ProfileTeoFt',
  // props: {
  // },
  components: {},
  setup: () => {
    return {};
  }
});
